import React from 'react';
import {useField} from 'formik';
import DatePicker, {
  Props as DatePickerProps,
  PropsWithoutDay as DatePickerWithoutDayProps,
} from './date-picker';

/**
  For use in Formik forms.

  Usage example:
  <FormikDatePicker
    monthLabel="Start month"
    monthName="startMonth"
    yearLabel="Start year"
    yearName="startYear"
    required
  />
*/

const FormikDatePicker = ({
  monthName,
  yearName,
  dayName,
  ...props
}: {monthName: string; yearName: string; dayName?: string} & Partial<DatePickerProps>) => {
  const [monthField, monthMeta, monthHelpers] = useField(monthName);
  const [yearField, yearMeta, yearHelpers] = useField(yearName);
  const [dayField, dayMeta, dayHelpers] = useField(dayName || 'no-day');

  const commonProps = {
    ...props,
    month: monthField.value,
    monthError: monthMeta.touched ? monthMeta.error : '',
    monthOnChange: (value) => {
      monthHelpers.setTouched(true);
      monthHelpers.setValue(parseInt(value));
    },
    year: yearField.value,
    yearError: yearMeta.touched ? yearMeta.error : '',
    yearOnChange: (value) => {
      yearHelpers.setTouched(true);
      yearHelpers.setValue(parseInt(value));
    },
  } as DatePickerWithoutDayProps;

  if (dayName) {
    return (
      <DatePicker
        {...commonProps}
        includeDay
        day={dayField.value}
        dayError={dayMeta.touched ? dayMeta.error : ''}
        dayOnChange={(value) => {
          dayHelpers.setTouched(true);
          dayHelpers.setValue(parseInt(value));
        }}
      />
    );
  }

  return <DatePicker {...commonProps} />;
};

export default FormikDatePicker;
